import styled from "styled-components";

export default styled.div`
  display: flex;
  height: 130px;
  padding: 10px;

  > * {
    margin: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/toolbar.js